import { Offer } from 'interfaces/Interfaces';

interface Message {
  sender: string;
  body: string;
  createdAt?: string;
  photo?: string;
  profilePicURL?: string;
}

const updateAnEntryWithNewRating = (entries: any, entryId: string, rating: number) => {
  let entryToBeUpdated = entries.filter((en: any) => en.id === entryId)[0];

  if (entryToBeUpdated) {
    entries.filter((en: any) => en.id === entryId)[0].ratings = rating;
  }

  return entries;
}

const updateAnEntryWithNewMessage = (entries: any, entryId: string, message: Message) => {
  let entryToBeUpdated = entries.filter((en: any) => en.id === entryId)[0];
  const newMessages: any = []
  if (entryToBeUpdated) {
    if (entryToBeUpdated.messages) {
      entryToBeUpdated.messages.push(message);
    } else {
      newMessages.push(message);
      entryToBeUpdated.messages = newMessages;
    }
  }
  return entries;
}

const updateAnEntryWithNewOffers = (entries: any, entryId: string, offer: Offer) => {
  let entryToBeUpdated = entries.filter((en: any) => en.id === entryId)[0];
  const newMessages: any = []
  if (entryToBeUpdated) {
    if (entryToBeUpdated.offers) {
      entryToBeUpdated.offers.push(offer);
    } else {
      newMessages.push(offer);
      entryToBeUpdated.offers = newMessages;
    }
  }

  return entries;
}

export default (state: any, action: { type: string; payload: any }) => {
  switch(action.type) {

  case 'SET_BUY_REQUEST_LOADER': {
    return {
      ...state,
      loading: action.payload.loader,
    }
  }

  case 'SET_BUY_REQUEST_DETAILS': {
    return {
      ...state,
      buyRequestDetails: action.payload.details,
    }
  }

  case 'SET_BUY_REQUEST_DETAILS_ERROR': {
    return {
      ...state,
      detailsError: `Error occured while fetching buy request details due to: ${action.payload.error}`,
    }
  }

  case 'ENTRIES_LOADER': {
    return {
      ...state,
      entriesLoader: action.payload.loader,
    }
  }

  case 'SET_ENTRIES_FOR_BUY_REQUEST': {
    return {
      ...state,
      entries: action.payload.entries,
      ratingStats: action.payload.ratingStats,
    }
  }

  case 'SET_ENTRIES_FOR_BUY_REQUEST_ERROR': {
    return {
      ...state,
      entriesError: `Error occured while fetching entries due to: ${action.payload.error}`,
    }
  }

  case 'SET_A_RATING_TO_AN_ENTRY': {
    return {
      ...state,
      entries: updateAnEntryWithNewRating(state.entries, action.payload.entryId, action.payload.rating),
    }
  }

  case 'SET_MSG_ON_BUY_REQUEST': {
    return {
      ...state,
      entries: updateAnEntryWithNewMessage(state.entries, action.payload.entryId, action.payload.message),
    }
  }

  case 'SET_OFFERS_ON_ENTRY': {
    return {
      ...state,
      entries: updateAnEntryWithNewOffers(state.entries, action.payload.entryId, action.payload.offer),
    }
  }

  default:
    return state;
  }
}
